// extracted by mini-css-extract-plugin
module.exports = {"campaignList":"campaignList_campaignList__1LIPF"};